import React from "react";
import { ComponentConfig } from "../../services/types/ComponentTypes";

interface CheckboxProps {
    config: ComponentConfig;
    value?: boolean | string | number;
    onChange?: (name: string, value: boolean) => void;
}

function isCheckboxChecked(value: boolean | string | number | undefined): boolean {
    if (value === true || value === 1) return true;
    if (typeof value === "string") {
        const s = value.trim().toLowerCase();
        return s === "true" || s === "1" || s === "yes" || s === "on";
    }
    return false;
}

export const Checkbox: React.FC<CheckboxProps> = ({
    config,
    value = false,
    onChange,
}) => {
    const isChecked = isCheckboxChecked(value);
    // specific properties not on base type
    const fieldConfig = config as any;
    const inputId = fieldConfig.name || fieldConfig.BindValue || "checkbox";
    const label = fieldConfig.Label || fieldConfig.label;

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        onChange?.(fieldConfig.BindValue || fieldConfig.name, e.target.checked);
    };

    const containerStyles: React.CSSProperties = {
        backgroundColor: config.style?.backgroundColor || "transparent",
        padding: config.style?.padding || 8, // reduced padding for checkbox
        borderRadius: config.style?.borderRadius || 8,
        margin: config.style?.margin || 0,
        width: "100%", // ensuring it takes full width of grid cell if needed, or adapt
    };

    return (
        <div style={containerStyles} className="flex items-center">
            <input
                type="checkbox"
                id={inputId}
                checked={isChecked}
                onChange={handleChange}
                disabled={fieldConfig.disabled}
                className="w-4 h-4 mr-2 cursor-pointer accent-success-600 dark:accent-success-500 rounded bg-gray-100 dark:bg-gray-700 border-gray-300 dark:border-gray-600 focus:ring-success-500 dark:focus:ring-success-400 focus:ring-2"
            />
            {label && (
                <label htmlFor={inputId} className="text-sm font-normal text-gray-900 dark:text-gray-100 cursor-pointer select-none font-sans">
                    {label}
                    {fieldConfig.required && <span className="text-danger-500 dark:text-danger-400 ml-1">*</span>}
                </label>
            )}
            {fieldConfig.helperText && (
                <div className="text-gray-500 dark:text-gray-400 text-xs ml-2 font-sans">{fieldConfig.helperText}</div>
            )}
        </div>
    );
};
